import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LoadingOverlay } from "@mantine/core";
import type { ReactNode } from "react";

export default function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return <LoadingOverlay visible />;
  if (!user) return <Navigate to="/login" replace />;

  return <>{children}</>;
}
